import httpLoad from "./http_loader.js"

let defaultParallelizePer = 3



//************************ Asset


let assetsMap = {}

function Asset (url) {
    this.loaded = false
    this.url    = url
    assetsMap[url] = this
}


Asset.find = function (url) {
    return assetsMap[url] || null
}


Asset.findOrCreate = function (url) {
    return Asset.find(url) || new Asset(url)
}




//************************ Asset Batch


function AssetBatch (options) {
    this.assets = []
    this.names  = []
    this.loadingQueue = {}

    options = options || {}

    this.withNames      = options.withNames
    this.parallelizePer = options.parallelizePer || defaultParallelizePer
    this.onProgress     = options.onProgress     || function () {}
    this.onComplete     = options.onComplete     || function () {}
    this.onError        = options.onError
}


AssetBatch.prototype.add = function (asset, name) {
    this.assets.push(asset)
    if (this.withNames) {
        this.names.push(name)
    }

    if (!asset.loaded) {
        this.loadingQueue[asset.url] = asset
    }
}


AssetBatch.prototype.loadAll = function () {
    this.loadError = new Error("")
    for (let i = 0; i < this.parallelizePer; i++) {
        this.loadNext()
    }
}


function loadFromQueue (assetBatch, url) {
    let asset = assetBatch.loadingQueue[url]

    if (asset.loading) {
        return false
    }
    asset.loading = true

    httpLoad(url, onLoadHandler(asset, assetBatch), assetBatch.onError || defaultLoadError(assetBatch, url))

    return true
}


function defaultLoadError (assetBatch, url) {
    return function () {
        assetBatch.loadError.message = `Could not load ${url}`
        throw assetBatch.loadError
    }
}


AssetBatch.prototype.loadNext = function () {
    for (let url in this.loadingQueue) {
        if (loadFromQueue(this, url)) {
            return
        }
    }

    if (!this.loadingQueueCount() && !this.completed) {
        this.completed = true
        if (this.withNames) {
            this.onComplete(getAssetBodiesWithNames(this.assets, this.names))
        } else {
            this.onComplete(...getAssetBodies(this.assets))
        }

    }

}


AssetBatch.prototype.loadingQueueCount = function () {
    let count = 0
    for (let key in this.loadingQueue) {
        if (this.loadingQueue.hasOwnProperty(key)) {
            count++
        }
    }

    return count
}


AssetBatch.prototype.progress = function () {
    let assetsCount = this.assets.length
    let loadedCount = assetsCount - this.loadingQueueCount()
    return loadedCount / assetsCount
}


function loadWithArray (urls, options) {
    let assetBatch = new AssetBatch(options)
    urls.forEach(function (url) {
        assetBatch.add(Asset.findOrCreate(url))
    })
    assetBatch.loadAll()
}


function loadWithObject (namedUrls, options) {
    options.withNames = true
    let assetBatch = new AssetBatch(options)
    for (let name in namedUrls) {
        assetBatch.add(Asset.findOrCreate(namedUrls[name]), name)
    }
    assetBatch.loadAll()
}


AssetBatch.load = function (urls, options) {
    if (Object.prototype.toString.call(urls) === "[object Array]") {
        loadWithArray(urls, options)
    } else {
        loadWithObject(urls, options)
    }
}




//************************ Helpers


function getAssetBodies (assets) {
    return assets.map(function (asset) {
        return asset.body
    })
}


function getAssetBodiesWithNames (assets, names) {
    let result = {}
    assets.forEach((asset, i) => {
        result[names[i]] = asset.body
    })
    return result
}


function onLoadHandler (asset, assetBatch) {
    return function (body) {
        delete assetBatch.loadingQueue[asset.url]

        asset.loaded  = true
        asset.loading = false
        asset.body    = body

        assetBatch.onProgress(body, assetBatch.progress())
        assetBatch.loadNext()
    }
}


export default AssetBatch

